import React, {useContext} from 'react';

//import motion
import { motion } from 'framer-motion';
// import transition
import {transition1} from '../transitions'
import { CursorContext } from '../context/CursorContext';

const Contact = () => {
  const {mouseEnterHandler, mouseLeaveHandler} = useContext(CursorContext);
  return <>
    <motion.section 
    initial={{ opacity:0, y: '100%' }} 
    animate={{ opacity:1, y:0 }} 
    exit={{ opacity:0, y:'100%' }}
    transition={transition1}
    className='section overflow-y-auto'>
    <div className='container mx-auto h-full'>
      <div className='flex flex-col lg:flex-row h-full items-center
      justify-start pt-36 gap-x-8 text-center lg:text-left'>
        {/* bg */}
        <motion.div 
          initial={{ opacity:0, y: '100%' }} 
          animate={{ opacity:1, y:0 }} 
          exit={{ opacity:0, y:'100%' }}
          transition={transition1}
          className='hidden lg:flex bg-[#f7f7f5] absolute bottom-0 left-0
        right-0 top-72 -z-10'>
        </motion.div>
        {/* text & form */}
        <div 
          onMouseEnter={mouseEnterHandler}
          onMouseLeave={mouseLeaveHandler}
          className='lg:flex-1 lg:pt-32 px-4'>
          <h1 className='h1 normal-case'>
            Get In Touch
          </h1>
          <p className='font-secondary font-light mb-5 max-w-3xl mx-auto lg:mx-0'>
            Based in Paris and available worldwide for editorial, travel, hospitality, and brand collaborations. I&apos;m always interested in working on projects with a strong sense of atmosphere and place.
          </p>
          <p className='font-secondary font-light mb-12 max-w-6xl mx-auto lg:mx-0'>
            For collaborations, licensing, or creative inquiries, feel free to get in touch below or via <strong className='font-normal'>emma.tysinger@gmail.com</strong>. And if you simply have feedback or a question, I&apos;d love to hear from you too.
          </p>
          {/* form */}
          <form className='flex flex-col gap-y-4 group'
          action="https://formbold.com/s/3NrDn"
          method="POST"
          noValidate>
            <div className='flex flex-col md:flex-row gap-x-10 gap-y-4 '>
              <label for="name" className='w-full'>
                <input className='outline-none border-b border-b-primary 
                h-[60px] bg-transparent font-secondary w-full pl-3 
                placeholder:text-[#757879]' type='text' placeholder='Your name' id="name" name='name' required/>
              </label>
              <label for="email" className='w-full'>
                <input className='outline-none border-b border-b-primary 
                h-[60px] bg-transparent font-secondary w-full pl-3 
                placeholder:text-[#757879]
                invalid:[&:not(:placeholder-shown):not(:focus)] peer' type='email' placeholder='Your email address' id="email" name='email' 
                required pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"/>
                <span className="mt-2 hidden text-sm text-red-500 peer-[&:not(:placeholder-shown):not(:focus):invalid]:block">
                  Please enter a valid email address
                </span>
              </label>
            </div>
            <input className='outline-none border-b border-b-primary 
              h-[60px] bg-transparent font-secondary w-full pl-3 
              placeholder:text-[#757879]' type='text' placeholder='Subject' id="subject" name="subject" required
            />
            <textarea className='outline-none border-b border-b-primary 
              h-[60px] bg-transparent font-secondary w-full pl-3 
              placeholder:text-[#757879]' type='text' placeholder='Your message' id="message" name="message" required
            />
            <button
              type='submit'
              className='group/btn inline-flex items-center gap-3 font-secondary text-sm uppercase tracking-[0.2em] text-primary mb-[30px] mx-auto lg:mx-0 self-center lg:self-start group-invalid:pointer-events-none group-invalid:opacity-30'
            >
              <span className='border-b border-primary/40 pb-1 transition-colors group-hover/btn:border-primary'>
                Send message
              </span>
              <span
                aria-hidden='true'
                className='transition-transform duration-300 group-hover/btn:translate-x-1'
              >
                &rarr;
              </span>
            </button>

          </form>
        </div>
      </div>
    </div>
    <footer className='flex footer w-full justify-center items-center pt-16 pb-8'>
      <div className="text-sm text-primary">
      Copyright © 2026 
      </div>
    </footer>
  </motion.section>
  </>;
};
export {Contact};

